import Dropdown from './Dropdown'

export default Dropdown



// WEBPACK FOOTER //
// ./src/components/Pricelist/Dropdown/index.js